export default {
    DATA: 'DD/MM/YYYY',
    DATA_HORA: 'DD/MM/YYYY [-] HH[h]',
    DATA_HORA_MINUTO: 'DD/MM/YYYY [-] HH[h] mm[min]',
    HORA: 'HH[h] mm[min]',
}
